module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/chevron-carousel-pc-90792abcd8b04ed477b71718ae93043d.svg";